module.exports = __webpack_public_path__ + "img/u121245.ad6eccfd.png";